<template>
    <button
        class="bg-gradient-to-b from-amber-600 to-amber-800 text-white rounded outline outline-amber-800 border border-white border-amber-100 hover:outline-amber-700 hover:shadow-md transition"
        :class="{'uppercase w-full p-2.5 font-medium': size === 'big', 'py-0.5 px-3 text-sm': size === 'small' }">
        <i v-if="isLoading" class="fa-solid fa-circle-notch animate-spin"></i>
        <slot v-if="!isLoading"/>
    </button>
</template>

<script setup>
import {defineExpose, defineProps, ref} from "vue";

defineProps({
    size: {
        type: String,
        default: 'small'
    },
    href: {
        type: String,
        default: null
    }
})

const isLoading = ref(false)

function toggleLoading() {
    isLoading.value = !isLoading.value
}

defineExpose({
    toggleLoading
})
</script>
